import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/Layout/index.vue';

const home = r => require.ensure([], () => r(require('@/views/dashboard/index')), 'home');
const login = r => require.ensure([], () => r(require('@/views/login/login')), 'login');
import adManage from './modules/adManage';
import membermanage from './modules/membMange';
import Accounts from './modules/Accounts';
import DetailList from './modules/DetailList';
import ConteMange from './modules/ConteMange';
import sortMange from './modules/sortMange';
import Secondhand from './modules/Secondhand';
import sysMange from './modules/sysMange';
import mallManage from './modules/mallManage';
import team from "./modules/teamMange"
import website from "./modules/website"
import major from "./modules/major";
import agent from "./modules/agent";
import creditManage from './modules/creditManage';
import videoMange from './modules/videoMange'; 
import designManage from './modules/designManage';
Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: Layout,
      children: [
        {
          path: '/home',
          component: home,
          name: 'home',
          meta: {
            title: '首页',
            keepAlive: false
          }
        },
        ...adManage,
        ...Accounts,
        ...membermanage,
        ...DetailList,
        ...ConteMange,
        ...sortMange,
        ...Secondhand,
        ...mallManage,
        ...sysMange,
        ...team,
        ...website,
        ...major,
        ...agent,
        ...creditManage,
        ...videoMange,
        ...designManage,
        // 意见反馈
        {
          path: '/suggest/suggest',
          component: resolve => require(['@/views/suggest/suggest'], resolve),
          name: 'suggest',
          meta: {
            title: '意见反馈'
          }
        },

      ]
    },
    {
      path: '/login',
      component: login,
      hidden: true
    },
    {
      path: '/404',
      component: resolve => require(['@/views/errorPage/404'], resolve),
      hidden: true
    },
    {
      path: '/403',
      component: resolve => require(['@/views/errorPage/401'], resolve),
      hidden: true
    },
    {
      path: '*',
      component: resolve => require(['@/views/errorPage/401'], resolve),
      hidden: true
    },
  ]

});



// WEBPACK FOOTER //
// ./src/router/index.js